import { Button, InputField } from "../components";
import { useRef } from "@/common/hooks";

const FileInput = ({ value, onChange = () => {}, ...rest }) => {
  const ref = useRef(null);

  return (
    <div className="form-group mt-4">
      <input
        {...rest}
        ref={ref}
        className="d-none"
        type="file"
        aria-label="File Upload"
        onChange={(e) => {
          if (e.target.value) {
            onChange([...e.target.files]);
          }
        }}
      />
      <InputField
        type="button"
        onClick={() => ref.current.click()}
        value={
          value.length ? value.map((f) => f.name).join(", ") : "Upload a file"
        }
      />
      <Button
        type="secondary"
        text="Browse"
        click={() => ref.current.click()}
      />
    </div>
  );
};

export default FileInput;
